<app-header></app-header>
<app-botao-chat></app-botao-chat>
<app-loading-generico [message]="loadingGenericoMessage" [loadingGenerico]="loadingGenerico" [buttons]="loadingGenericoData.buttons"></app-loading-generico>

<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <div class="div-titulo-pagina">
          <h1>Informe de Rendimentos</h1>
          <h2>No Informe de Rendimentos você conseguirá visualizar os valores retidos de imposto sobre a cobrança dos
          pagamentos feita pela Alelo.</h2>
        </div>
        <form [formGroup]="formFiltro" style="min-height: 100%">
          <div class="filtro-informe-rendimento">
            <div class="filtro-ano-reinf">
              <mat-form-field class="ano-reinf" appearance="outline">
                <mat-label class="mat-label-text">Busque por um ano</mat-label>
                <input matInput type="text" maxlength="4" id="inputAnoReinf" formControlName="ano"
                  (change)="verificaAnoPreenchido()">
                <mat-icon matSuffix style="margin-top: -15px">
                  <svg
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.50008 1.41591C6.50008 0.955677 6.12699 0.582581 5.66675 0.582581C5.20651 0.582581 4.83341 0.955677 4.83341 1.41591V2.24925H4.00008C2.15913 2.24925 0.666748 3.74163 0.666748 5.58258V15.5826C0.666748 17.4235 2.15913 18.9159 4.00008 18.9159H14.0001C15.841 18.9159 17.3334 17.4235 17.3334 15.5826V5.58258C17.3334 3.74163 15.841 2.24925 14.0001 2.24925H13.1667V1.41591C13.1667 0.955677 12.7937 0.582581 12.3334 0.582581C11.8732 0.582581 11.5001 0.955677 11.5001 1.41591V2.24925H6.50008V1.41591ZM12.3334 4.74925C11.8732 4.74925 11.5001 4.37615 11.5001 3.91591H6.50008C6.50008 4.37615 6.12699 4.74925 5.66675 4.74925C5.20651 4.74925 4.83341 4.37615 4.83341 3.91591H4.00008C3.07961 3.91591 2.33341 4.66211 2.33341 5.58258V7.24925H15.6667L15.6667 5.58258C15.6667 4.66211 14.9206 3.91591 14.0001 3.91591H13.1667C13.1667 4.37615 12.7937 4.74925 12.3334 4.74925ZM15.6667 8.91591H2.33341V15.5826C2.33341 16.5031 3.07961 17.2492 4.00008 17.2492H14.0001C14.9206 17.2492 15.6667 16.5031 15.6667 15.5826L15.6667 8.91591ZM9.84155 11.4159C9.84156 11.8761 9.46847 12.2492 9.00823 12.2492H8.99987C8.53963 12.2493 8.16653 11.8762 8.16652 11.4159C8.16652 10.9557 8.53961 10.5826 8.99985 10.5826H9.00821C9.46845 10.5826 9.84155 10.9557 9.84155 11.4159ZM9.00823 15.5826C9.46847 15.5826 9.84156 15.2095 9.84155 14.7492C9.84155 14.289 9.46845 13.9159 9.00821 13.9159H8.99985C8.53961 13.9159 8.16652 14.289 8.16652 14.7493C8.16653 15.2095 8.53963 15.5826 8.99987 15.5826H9.00823ZM14.0082 11.4159C14.0082 11.8761 13.6351 12.2492 13.1749 12.2492H13.1665C12.7063 12.2493 12.3332 11.8762 12.3332 11.4159C12.3332 10.9557 12.7063 10.5826 13.1665 10.5826H13.1749C13.6351 10.5826 14.0082 10.9557 14.0082 11.4159ZM13.1749 15.5826C13.6351 15.5826 14.0082 15.2095 14.0082 14.7492C14.0082 14.289 13.6351 13.9159 13.1749 13.9159H13.1665C12.7063 13.9159 12.3332 14.289 12.3332 14.7493C12.3332 15.2095 12.7063 15.5826 13.1665 15.5826H13.1749ZM5.43081 10.8267C5.75625 11.1521 5.75625 11.6797 5.43081 12.0052L5.42247 12.0135C5.09703 12.3389 4.56939 12.3389 4.24396 12.0135C3.91852 11.6881 3.91852 11.1604 4.24396 10.835L4.2523 10.8267C4.57773 10.5012 5.10537 10.5012 5.43081 10.8267ZM4.84156 15.5826C5.3018 15.5826 5.67489 15.2095 5.67489 14.7492C5.67488 14.289 5.30178 13.9159 4.84154 13.9159H4.83318C4.37294 13.9159 3.99985 14.289 3.99986 14.7493C3.99986 15.2095 4.37296 15.5826 4.8332 15.5826H4.84156Z"
                      fill="#878787"
                      />
                  </svg>
                </mat-icon>
              </mat-form-field>
              <mat-error>{{ formFiltro.get('ano').errors?.message }}</mat-error>
            </div>

            <div class="filtro-botoes-reinf">
              <button type="button" class="botao-buscar-reinf btn-grande-verde" id="btnAnoReinf"
                (click)="buscar()" [disabled]="buscaInativa()">BUSCAR
              </button>
              @if (this.formFiltro.get('ano')?.value || this.formFiltro.get('empresa')?.value) {
                <button class="filtro-limpar"
                  (click)="limparFiltro()">
                  LIMPAR BUSCA
                </button>
              }
            </div>
            <div class="select-empresa-reinf">
              <app-select-one [label]="'Busque por um CNPJ ou Razão social'"
                class="filtro-empresa-reinf"
                [buscaComPesquisa]="true"
                [buscaIdDesc]="true"
                (valueChanges)="onChangeEmpresa($event)"
                [valorPadrao]="valorPadrao"
                [descricaoPadrao]="descricaoPadrao"
                formControlName="empresa"
                id="slctEmpresaReinf"
                [enterPesquisar]="enterPesquisar"
                [collection]="empresasGrupo"
                [panelWidth]="'500px'"
                [fieldWidth]="330" >
              </app-select-one>
            </div>
          </div>
        </form>
        <div class="container">
          <div class="row">
            <div style="width: 100%;display: flex;justify-content: end">
              <button type="button" class="botao-download-informe" id="btnInformeRendimentos"
                (click)="iniciaCriacaoZip()" [ngClass]="{ 'botao-download-all': baixouTodos === true || listaInformesSelecionados.length > 0 }">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.7513 8.75C2.07347 8.75 2.33464 9.01117 2.33464 9.33333V10.5C2.33464 11.1443 2.85697 11.6667 3.5013 11.6667H10.5013C11.1456 11.6667 11.668 11.1443 11.668 10.5V9.33333C11.668 9.01117 11.9291 8.75 12.2513 8.75C12.5735 8.75 12.8346 9.01117 12.8346 9.33333V10.5C12.8346 11.7887 11.79 12.8333 10.5013 12.8333H3.5013C2.21264 12.8333 1.16797 11.7887 1.16797 10.5V9.33333C1.16797 9.01117 1.42914 8.75 1.7513 8.75Z" fill="#008060"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.0013 9.33301C6.67914 9.33301 6.41797 9.07184 6.41797 8.74967L6.41797 1.74967C6.41797 1.42751 6.67914 1.16634 7.0013 1.16634C7.32347 1.16634 7.58464 1.42751 7.58464 1.74967L7.58463 8.74967C7.58463 9.07184 7.32347 9.33301 7.0013 9.33301Z" fill="#008060"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M3.67085 5.42085C3.44305 5.64866 3.44305 6.01801 3.67085 6.24581L6.58752 9.16248C6.81533 9.39028 7.18467 9.39028 7.41248 9.16248L10.3291 6.24581C10.557 6.01801 10.557 5.64866 10.3291 5.42085C10.1013 5.19305 9.73199 5.19305 9.50419 5.42085L7 7.92504L4.49581 5.42085C4.26801 5.19305 3.89866 5.19305 3.67085 5.42085Z" fill="#008060"/>
                </svg>
                {{ isBaixarTodos() || allCheckBoxesClicked()? 'BAIXAR TODOS' : 'BAIXAR SELECIONADOS' }}
              </button>
            </div>
          </div>
        </div>
        <div>
          @if (empresasPrincipais?.length > 0) {
            <app-data-table
              dataTableId="dataTable-Matriz"
              [selectable]="true"
              [selectAllEnabled]="false"
              [downloadable]="true"
              [columns]="colunasMatriz"
              [data]="empresasPrincipais"
              (updateDataTable)="getEmpresa()"
              (download)="iniciaCriacaoPdf($event)"
              (selectRow)="checkboxTableClickMatriz($event)">
            </app-data-table>
          }
        </div>
        <div style="margin-top: 60px;">
          @if (empresasFiliais?.length > 0) {
            <app-data-table
              dataTableId="dataTable-Filiais"
              [paginated]="true"
              [pagination]="paginacaoFilial"
              [lazy]="false"
              [selectAllEnabled]="true"
              [selectable]="true"
              [downloadable]="true"
              [columns]="colunasFilial"
              [data]="empresasFiliais"
              (updateDataTable)="getEmpresa()"
              (download)="iniciaCriacaoPdf($event)"
              (selectAllRows)="selecionaTodosFilial($event)"
              (selectRow)="checkboxTableClickFilial($event)">
            </app-data-table>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
